<template>
  <div class="absolute w-screen h-screen overflow-hidden z-[10000] bg-backgroundSecondary">
    <div class="w-full h-full flex flex-col overflow-y-auto">
      <div class="h-[44px] md:h-[72px] mx-4 my-10 md:my-6 px-2 md:px-7 flex flex-row justify-between items-center">
        <div>
          <img src="@/assets/images/logo.webp" />
        </div>
        <VaButton color="white" round class="w-[44px] h-[44px]" @click="userStore.hideSidebar">
          <VaIcon name="close" size="28px" color="primary" @click="userStore.hideSidebar" />
        </VaButton>
      </div>

      <div class="p-4 place-self-end">
        <VaMenuList>
          <RouterLink
            v-for="item in menuItems" :key="item.textKey"
            :to="item.route" @click="userStore.hideSidebar"
          >
            <VaMenuItem class="text-2xl">
              <div class="w-full text-right">
                {{ t(item.textKey) }}
              </div>
            </VaMenuItem>
          </RouterLink>
        </VaMenuList>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VaButton, VaIcon, VaMenuItem, VaMenuList } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/UserStore'
import { computed } from 'vue'

const userStore = useUserStore()
const { t } = useI18n()

const menuItems = computed(() => {
  if (!userStore.isLoggedIn) {
    return [
      { textKey: 'menu.login', route: { name: 'login' } },
      { textKey: 'menu.register', route: { name: 'register' } },
    ]
  }

  return [
    { textKey: 'menu.home', route: { name: 'home' } },
    { textKey: 'menu.logout', route: { name: 'logout' } },
  ] // .filter(item => !item.disabled)
})
</script>
